import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { Tkv2ReferenceBarItem } from './Tkv2ReferenceBarItem.tsx';
import { useTkv2HandleIconClick } from './useTkv2HandleIconClick.ts';

export const Tkv2HelpDrawerItem = () => {
  const { referenceViewOpen, selectedDataSheet } = useAppSelector(selectReferenceBarUI);
  const handleIconClick = useTkv2HandleIconClick();

  const isSelected = selectedDataSheet === 'help-drawer' && referenceViewOpen;

  return (
    <Tkv2ReferenceBarItem
      id="page_guide"
      label="Page Guide"
      icon="information"
      isSelected={isSelected}
      onClick={() => handleIconClick('help-drawer')}
    />
  );
};
